import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/siteData";

export default function FaqSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="入坑前最常问的几个问题"
          desc="店主是谁、洞是干嘛的、主要人物有哪些——先来快速扫盲。"
        />
        <div className="mt-10">
          <FaqAccordion items={faqs.slice(0, 4)} />
        </div>
        <div className="mt-8 text-center">
          <Link
            to="/faq"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-bold text-primary-700 transition-colors hover:text-primary-800"
          >
            查看全部问答
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}